// extracted by mini-css-extract-plugin
export default {"root":"IconCheckCircle_root__u3cEj"};